import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography, Container, Paper, Grid } from '@mui/material';
import { blogs } from '../data/blogs';

const BlogDetail = () => {
  const { slug } = useParams();
  const blog = blogs.find((b) => b.slug === slug);

  useEffect(() => {
    if (blog) {
      document.title = blog.metaTitle || `${blog.title} | CoreTechTalks`;
      
      const metaDesc = document.querySelector('meta[name="description"]');
      if (metaDesc) {
        metaDesc.setAttribute("content", blog.metaDescription || blog.excerpt);
      }

      let metaKeywords = document.querySelector('meta[name="keywords"]');
      if (blog.keywords && blog.keywords.length > 0) {
        const keywordsStr = blog.keywords.join(", ");
        if (metaKeywords) {
          metaKeywords.setAttribute("content", keywordsStr);
        } else {
          metaKeywords = document.createElement('meta');
          metaKeywords.setAttribute("name", "keywords");
          metaKeywords.setAttribute("content", keywordsStr);
          document.head.appendChild(metaKeywords);
        }
      }
    }
    return () => {
      document.title = "CoreTechTalks";
      const metaDesc = document.querySelector('meta[name="description"]');
      if (metaDesc) {
        metaDesc.setAttribute("content", "CoreTechTalks - Insights, tools, and guides on modern technology, app development, and technical tutorials.");
      }
      const metaKeywords = document.querySelector('meta[name="keywords"]');
      if (metaKeywords) {
        metaKeywords.remove();
      }
    };
  }, [blog]);

  if (!blog) {
    return (
      <Box sx={{ flexGrow: 1, py: 8, textAlign: 'center' }}>
        <Typography variant="h5">Blog post not found</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ flexGrow: 1, py: 8, backgroundColor: 'transparent' }}>
      <Container maxWidth="md">
        <Paper sx={{ p: { xs: 2, md: 4 } }}>
          <Typography variant="h2" component="h1" gutterBottom>
            {blog.title}
          </Typography>
          <Grid container alignItems="center" spacing={2} sx={{ mb: 2 }}>
            <Grid size={12}>
              <Typography variant="subtitle1">{blog.author}</Typography>
              <Typography variant="subtitle2" color="text.secondary">{blog.date}</Typography>
            </Grid>
          </Grid>
          {blog.image && (
            <Box
              component="img"
              src={blog.image}
              alt={blog.title}
              sx={{
                  width: '100%',
                  height: 'auto',
                  maxHeight: 'none',
                  objectFit: 'contain',
                  borderRadius: '12px',
                  mb: 4,
                  display: 'block',
                  backgroundColor: '#fff'
                }}
            />
          )}
          <Box
            sx={{
              lineHeight: 1.8,
              '& h2': {
                fontSize: '1.75rem',
                fontWeight: 600,
                my: 3,
              },
              '& h3': {
                fontSize: '1.5rem',
                fontWeight: 600,
                my: 2,
              },
              '& p': {
                mb: 2,
              },
              '& ul, & ol': {
                pl: 3,
                mb: 2,
              },
              '& li': {
                mb: 1,
              },
            }}
            dangerouslySetInnerHTML={{ __html: blog.content }}
          />
        </Paper>
      </Container>
    </Box>
  );
};

export default BlogDetail;
